import sortBy from "lodash/sortBy";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

class UptimeChart extends React.Component {
  static get displayName() {
    return "UptimeChart";
  }

  static get propTypes() {
    return {
      data: PropTypes.object.isRequired,
    };
  }

  render() {
    if (!this.props.data) {
      return undefined;
    }

    let data = [];
    for (let [date, uptime] of Object.entries(this.props.data)) {
      data.push({
        date: moment(date),
        uptime: uptime,
      });
    }

    data = sortBy(data, "date");

    return <div className="uptime-chart">{this._renderChart(data)}</div>;
  }

  _renderChart(data) {
    const boxes = [];
    const width = 100 / data.length;
    for (let [index, row] of Object.entries(data)) {
      const style = {
        width: `${width}%`,
        height: "100%",
        borderRight: "1px solid #fff",
        display: "block",
        backgroundColor: this._color(row.uptime),
      };
      const title =
        `${row.date.format("MM/DD/YYYY")}: ` +
        `${Number(row.uptime).toFixed(2)}%`;
      boxes.push(<span key={index} title={title} style={style}></span>);
    }

    return boxes;
  }

  _color(uptime) {
    if (uptime > 95) {
      return "#00a65a";
    } else if (uptime > 60) {
      return "#f39c12";
    }

    return "#dd4b39";
  }
}

module.exports = UptimeChart;
